import { errorStatuses, IError, responseStatusCodes } from './requestErrorType';
import { VariantType } from 'notistack';

export const handleErrors = (
  errors: Array<IError>,
  errorStatus: keyof typeof errorStatuses,
  responseStatusCode: keyof typeof responseStatusCodes,
  onCreateNotification: (message: string, variant?: VariantType) => void
) => {
  errors.length &&
    errors.forEach(error => {
      if (error.type !== 'RefreshToken') {
        onCreateNotification(error.message, 'error');
      }
    });
};
